export default __webpack_public_path__ + "static/media/opinion_bottom.bc414af7.svg";